module.exports = __webpack_public_path__ + "static/media/web_shop.02f3231a.svg";